import { Button, Card, Modal } from "react-bootstrap";

function ModalFooter(props:any) {
  const { close } = props;
  return (
    <Modal.Footer>
      <Card style={{ width: "100%", margin: 0 }}>
        <Card.Body style={{ padding: "0.5rem" }}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              variant="primary"
              onClick={() => close()}
              style={{ margin: "5px" }}
            >
              Close
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Modal.Footer>
  );
}

export default ModalFooter;